import { guideSteps } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function Guide() {
  return (
    <section id="guide" className="w-full bg-background-50 px-4 py-16 md:px-8 md:py-24">
      <div className="mx-auto w-full max-w-6xl">
        <SectionHeading
          eyebrow="观看指引"
          title="四步走，不用来回试错"
          desc="无论你是想追剧、看文字还是看画面，按这四步走一遍，基本就能锁定适合自己的入口。"
          align="center"
        />

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {guideSteps.map((item, idx) => (
            <div
              key={item.step}
              className="relative flex flex-col rounded-lg border border-background-200 bg-background-100/70 p-5"
            >
              <span className="font-heading text-3xl font-black text-primary-200">{item.step}</span>
              <h3 className="mt-3 font-heading text-base font-bold text-foreground-950">
                {item.title}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
                {item.desc}
              </p>
              {idx < guideSteps.length - 1 ? (
                <i className="ri-arrow-right-line absolute -right-3 top-1/2 hidden -translate-y-1/2 text-xl text-background-400 lg:block"></i>
              ) : null}
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-4 rounded-lg border border-primary-200 bg-primary-50 p-6 md:flex-row">
          <div className="flex items-start gap-3">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-500 text-background-50 dark:text-foreground-950">
              <i className="ri-question-answer-line text-xl"></i>
            </span>
            <div>
              <p className="font-heading text-base font-bold text-foreground-950">
                还是拿不定主意看哪个版本？
              </p>
              <p className="mt-1 text-sm text-foreground-700">
                先去「无删减说明」对照片长与差异，再回到资源导航里挑选通道即可。
              </p>
            </div>
          </div>
          <a
            href="#resources"
            className="w-full shrink-0 cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-center font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:w-auto dark:text-foreground-950"
          >
            前往资源导航
          </a>
        </div>
      </div>
    </section>
  );
}